import {ACTION_TYPE} from '../../core/redux/actionType';
import {ApiReducer, makeApiAction, makeApiReducer, RsaaTypes} from '../../core/redux/api/reduxStandardApiAction';
import {IAppState} from '../../core/redux/IAppState';
import {checkUserNameAvailable} from '../../core/redux/api/endpoints';
import {hasTrippedBreaker, updateBreaker} from '../../core/redux/api/circuitBreaker/module';
import {addLoading, getLoading, removeLoadingAndError} from '../../core/redux/api/module';
import {assoc} from '../../language/module';


export const KEY_ACTION = ACTION_TYPE.CHECK_USERNAME_REQUEST;

export const ACTIONS = [
  ACTION_TYPE.CHECK_USERNAME_REQUEST,
  ACTION_TYPE.CHECK_USERNAME_RESPONSE,
  ACTION_TYPE.CHECK_USERNAME_ERROR
]

export const checkUsernameAction = (username: string) => makeApiAction(
  {
    method: 'GET',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: checkUserNameAvailable(username),
    types: ACTIONS.map(action => ({ type: action })) as RsaaTypes,
    bailout: (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION || !!getLoading(state, KEY_ACTION, KEY_ACTION)),
  },
);

const reducer: ApiReducer<boolean> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error || payload === undefined) {
    return withBreaker;
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc('usernameAvailable', payload, noLoadingOrError);
}

export const checkUsernameReducer = makeApiReducer(ACTIONS, KEY_ACTION, reducer);